export const CANADIAN_PROVINCE_OPTIONS = [
  { value: 'ALBERTA', label: 'Alberta' },
  { value: 'BRITISH_COLUMBIA', label: 'British Columbia' },
  { value: 'MANITOBA', label: 'Manitoba' },
  { value: 'NEW_BRUNSWICK', label: 'New Brunswick' },
  { value: 'NEWFOUNDLAND_AND_LABRADOR', label: 'Newfoundland and Labrador' },
  { value: 'NORTHWEST_TERRITORIES', label: 'Northwest Territories' },
  { value: 'NUNAVUT', label: 'Nunavut' },
  { value: 'NOVA_SCOTIA', label: 'Nova Scotia' },
  { value: 'ONTARIO', label: 'Ontario' },
  { value: 'PRINCE_EDWARD_ISLAND', label: 'Prince Edward Island' },
  { value: 'QUEBEC', label: 'Quebec' },
  { value: 'SASKATCHEWAN', label: 'Saskatchewan' },
  { value: 'YUKON', label: 'Yukon' },
] as const;

export const COUNTRY_CANADA = 'Canada' as const;



